<template>
    <div class="footers">
            <div class="bottoms">
              <div class="logo">
                  <img :src="logo" alt="">
              </div>
            </div>
            <div class="texts">
              <div v-html="footerTexts"></div>
               <!-- <div style="text-indent: 2em;">
                {{ $t('影视投资服务由1',{'titleName':titleName}) }}
               </div>
               <div style="text-indent: 2em;">
                {{ $t('影视投资服务由2',{'titleName':titleName}) }}
               </div>
               <div style="text-indent: 2em;">
                {{ $t('影视投资服务由3',{'titleName':titleName}) }}
               </div>
               <div style="text-indent: 2em;">
                {{ $t('影视投资服务由4',{'titleName':titleName}) }}
               </div>
               <div style="text-indent: 2em;">
                {{ $t('影视投资服务由5',{'titleName':titleName}) }}
               </div> -->
            </div>
            <div class="text">
                <p>
                  © 2026 Warner Bros. Discovery, Inc. or its subsidiaries and affiliates. 
                </p>
                <p>
                  All trademarks are the property of their respective owners. All rights reserved. 
                </p>
            </div>
        <!-- <div class="tops">
            <img :src="logo" alt=""  class="logo">
            <div class="email">
                <span>{{ this.$t('获得您更多的优惠券') }}</span>
                <input v-model.trim="email" :placeholder="this.$t('您的电子邮箱')" :maxlength="50" />
                <button @click="subscription">{{ this.$t('订阅') }}</button>
            </div>
            <ul>
                <li v-for="item in textList" :key="item.id"
                    class="en_li">
                    <div class="title">{{ item.title }}</div>
                    <div class="text" v-show="sub?.text" v-for="sub in item.subset" :key="sub.id"
                        @click="handleJump(sub)">
                        {{ sub.text }}
                    </div>
                </li>
            </ul>
        </div>
        <div class="mid">
            <div class="title">{{ this.$t('支付方式') }}</div>
            <ul>
                <li v-for="(item, index) of paymentList" :key="index" @click="handleJump(item)">
                    <img :src="item?.icon" alt="">
                    <span>{{ item?.name }}</span>
                </li>
            </ul>
        </div>
        <div class="texts">
            {{ $t('影视投资服务由') }}
        </div>
        <div class="text">
            <p>
              © 2025 Warner Bros. Discovery, Inc. or its subsidiaries and affiliates. 
            </p>
            <p>
              All trademarks are the property of their respective owners. All rights reserved. 
            </p>
        </div> -->
    </div>
</template>
<script>
import { Toast, Icon } from 'vant'
import Fetch from "@/utils/fetch";
export default {
    data() {
        return {
            logo:localStorage.getItem('logo') || '',
            footerTexts:'',
            titleName:localStorage.getItem('web_name') || '',
            // textList:[
            //     {
            //         title: this.$t('客户服务'),
            //         subset: [
            //             {
            //                 path:'',
            //                 text: this.$t('在线客服')
            //             },
            //         ]
            //     },
            //     {
            //         title: this.$t('隐私和政策'),
            //         subset: [
            //             {
            //                 path: '/promote/#/privacyPolicy',
            //                 text: this.$t('隐私政策')
            //             },
            //         ]
            //     },
            //     {
            //         title: this.$t('用户中心'),
            //         subset: [
            //             {
            //                 path: '/register',
            //                 text: this.$t('用户注册')
            //             },
            //             {
            //                 path: '/me',
            //                 text: this.$t('我的钱包')
            //             }
            //         ]
            //     },
            //     {
            //         title: this.$t('关于我们'),
            //         subset: [
            //             {
            //                 path: 'https://java-shop.piwfynwbgv.bond/#/credit',
            //                 text: this.$t('关于我们')
            //             },
            //         ]
            //     },
            // ],
            // email:'',
            // logo:localStorage.getItem('logo') || '',
            // worryFreeData: [
            //     {
            //         name: this.$t('灵活额度'),
            //         desc: this.$t('100,000至30,000,000，额度灵活， 没有限制，最长贷款期限一年。'),
            //         icon: require('@/assets/images/worry_free1.png'),
            //         iconName: 'meiyuan9'
            //     },
            //     {
            //         name: this.$t('急速放款'),
            //         desc: this.$t('最快一小时通过审核，审核通过 立马下款。'),
            //         icon: require('@/assets/images/worry_free2.png'),
            //         iconName: 'huojianjiasu'
            //     },
            //     {
            //         name: this.$t('安全无忧'),
            //         desc: this.$t('无抵押贷款，无需押金，不打回访电话， 这本就是一件私密的事。'),
            //         icon: require('@/assets/images/worry_free3.png'),
            //         iconName: 'dunpai'
            //     }
            // ],
            // isCheckAvailability: 'false',
            // partnerIcon: [],
            // paymentList: [
            //     {
            //         path: 'https://www.binance.com/',
            //         icon: require('@/assets/images/footer/1.png'),
            //         name: 'Binance'
            //     },
            //     {
            //         path: 'https://www.huobi.com/',
            //         icon: require('@/assets/images/footer/2.png'),
            //         name: 'Huobi'
            //     },
            //     {
            //         path: '',
            //         icon: require('@/assets/images/footer/3.png'),
            //         name: 'OKX'
            //     },
            //     {
            //         path: '',
            //         icon: require('@/assets/images/footer/4.png'),
            //         name: 'Kraken'
            //     },
            //     {
            //         path: 'https://www.dbs.com.sg/',
            //         icon: require('@/assets/images/footer/5.png'),
            //         name: 'coinbase'
            //     },
            //     {
            //         path: 'https://www.hsbc.com.hk/',
            //         icon: require('@/assets/images/footer/6.png'),
            //         name: 'MetaMask'
            //     },
            //     {
            //         path: 'https://portal.vietcombank.com.vn/',
            //         icon: require('@/assets/images/footer/7.png'),
            //         name: 'KuCoin'
            //     },
            //     {
            //         path: 'https://www.nab.com.au/',
            //         icon: require('@/assets/images/footer/8.png'),
            //         name: 'Bitfinex'
            //     },
            // ]
        }
    },
    mounted() {
      Fetch('/index/webconfig', { type: 'web' }).then(res => {
				this.footerTexts = res.data.footer_content
      })
        // const paths = [
        //         'https://www.cimbclicks.com.my',
        //         'https://www.cimb.com.my',
        //         'https://www.rhbgroup.com',
        //         'https://www.loanstreet.sg/',
        //         'https://www.dbs.com.sg/',
        //         'https://www.graceloanadvance.com',
        //         'https://hk.lendela.com',
        //         'https://epaycash.hk',
        //         'https://www.hangseng.com/',
        //         'https://www.hsbc.com.hk',
        // ]
        // for (let i = 0; i < 10; i++) {
        //         this.partnerIcon.push({
        //             icon: require(`@/assets/images/partner/${i + 1}.jpg`),
        //             path: paths[i]
        //         })
        // }
    },
    methods: {
        subscription() {

        },
        handleJump(path) {
            if (window.plus) {
                plus.runtime.openURL(encodeURI(path + '?wt=app'))
                return
            } else {
                window.open(path)
            }
        },
        handleMine() {
            this.$router.push('/loanMy')
        }
    }
}
</script>

<style lang="scss" scoped>
//   底部公用
.footers {
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 0px !important;
    .titles {
      color: #333;
      font-size: 28px;
      font-weight: bold;
      text-align: center;
    }
    .title2 {
      color: #333;
      font-size: 15px;
      margin: 15px auto;
    }
    .list2 {
        display: flex;
        width:100%;
        margin: 0 auto 25px auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 0 15px;
        img {
          display: block;
          width: 22%;
          object-fit: contain;
          margin: 8px 0px;
        }
    }
    .list_box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 0px 35px 0px;
      a {
        position: relative;
        display: block;
        width: 36px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        margin: 0px 20px;
        border-radius: 6px;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
        span {
          font-size: 40px;
          color: #000;
        }
      }
    }
    .bottoms {
      width: 100%;
      height: fit-content;
      background: #04006C;
      padding:20px 20px 0 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .lists {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 25px 20px 45px 20px;
        a {
          display: flex;
          width: 32px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          margin: 0px 10px;
          border-radius: 6px;
          span {
            font-size: 20px;
            color: #fff;
          }
        }
      }
      .logo {
        width: 220px;
        height: fit-content;
        padding-bottom: 30px;
        img {
          display: block;
          width: 100%;
          height: auto;
        }
      }
    }
    .texts {
      width: 100%;
      height: fit-content;
      padding: 0 15px 30px 15px;
      background: #04006C;
      color: #fff;
      font-size: 13px;
      line-height: 18px;
      text-indent: 2em;
    }
    .text {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-bottom: 120px;
      background: #04006C;
      p {
        width: 100%;
        font-size: 10px;
        margin: 5px auto;
        text-align: center;
        color: #fff;
      }
    }
}
// .footers {
// 	width: 100%;
// 	height: fit-content;
// 	background: #212121;
// 	.tops {
//         padding: 28px 38px 38px 28px;


//         .logo {
//             // width: 118px;
//             width: auto;
//             height: 35px;
//         }

//         .email {
//             margin-top: 0px;

//             span {
//                 display: block;
//                 color: #F89900;
//                 font-size: 12px;
//             }

//             input {
//                 margin-top: 12px;
//                 width: 288px;
//                 height: 44px;
//                 border-radius: 4px;
//                 padding-left: 10px;
//                 border: none;
//                 outline: none;
//                 font-size: 12px;
// 				background: #fff;

//                 &::placeholder {
//                     color: #9E9E9E;
//                 }
//             }

//             button {
//                 margin-top: 39px;
//                 width: 156px;
//                 height: 42px;
//                 border: 1px solid #F89900 !important;
//                 border-radius: 4px;
//                 font-size: 12px;
//                 color:#F89900;
//                 background: transparent;
//             }
//         }

//         ul {
//             margin-top: 29px;
//             display: flex;
//             flex-wrap: wrap;
//             justify-content: space-between;

//             li {
//                 flex: 0 0 70%;
//                 color: #fff;
//                 display: flex;
//                 flex-direction: column;
//                 align-items: flex-start;

//                 &.tr_li,
//                 &.it_li,
//                 &.af_li,
//                 &.ru_li,
//                 &.es_li,
//                 &.pt_li,
//                 &.ms_li,
//                 &.fr_li,
//                 &.de_li,
//                 &.en_li {
//                     flex: 0 0 55%;

//                     &:nth-child(2n) {
//                         align-items: flex-end;
//                         flex: 0 0 45%;
//                     }
//                 }

//                 &.de_li {
//                     flex: 0 0 50%;
//                 }

//                 &.fr_li {
//                     flex: 0 0 52%;
//                 }

//                 &.ms_li {
//                     flex: 0 0 50%;
//                 }

//                 &.pt_li {
//                     flex: 0 0 40%;
//                 }

//                 &.es_li {
//                     flex: 0 0 40%;
//                 }

//                 &.ru_li {
//                     flex: 0 0 50%;
//                 }

//                 &.af_li {
//                     flex: 0 0 50%;
//                 }

//                 &.tr_li {
//                     flex: 0 0 42%;
//                 }

//                 &.it_li {
//                     flex: 0 0 45%;
//                 }

//                 &.el_li {
//                     flex: 0 0 45%;

//                     &:nth-child(2n) {
//                         align-items: flex-end;
//                         flex: 0 0 50%;
//                     }
//                 }

//                 &.ja_li {
//                     flex: 0 0 50%;

//                     &:nth-child(2n) {
//                         align-items: flex-end;
//                         flex: 0 0 48%;
//                     }
//                 }

//                 &.ph_li {
//                     flex: 0 0 50%;

//                     &:nth-child(2n) {
//                         align-items: flex-end;
//                         flex: 0 0 48%;
//                     }
//                 }

//                 div {
//                     width: 100%;
//                     text-align: start;

//                     &.title {
//                         color: #F8990A;
//                         font-weight: 700;
//                         font-size: 16px;
//                         // margin-bottom: 19px;
//                         height: 45px;
//                         word-wrap: break-word;
//                     }

//                     &.text {
//                         // margin-bottom: 23px;
//                         height: 40px;
//                         font-size: 12px;
//                         transform: translateX(4px);
//                     }
//                 }

//                 &:nth-child(2n) {
//                     align-items: flex-end;
//                     flex: 0 0 30%;
//                 }

//                 &:nth-child(3),
//                 &:nth-child(4) {
//                     margin-top: 23px;
//                 }
//             }
//         }
//     }
// 	.mid {
//         padding: 13px 39px 31px 27px;
//         position: relative;

//         &::after {
//             content: '';
//             display: block;
//             position: absolute;
//             top: 0;
//             left: 50%;
// 			transform: translateX(-50%);
//             width: 90%;
//             height: 1px;
//             background: #3f3f3f;
//         }

//         &::before {
//             content: '';
//             display: block;
//             position: absolute;
//             bottom: 0;
//             left: 50%;
// 			transform: translateX(-50%);
//             width: 90%;
//             height: 1px;
//             background: #3f3f3f;
//         }

//         .title {
//             color: #fff;
//             font-size: 12px;
//             text-align: center;
//         }

//         ul {
//             margin-top: 29px;
//             display: flex;
//             flex-wrap: wrap;
//             justify-content: center;
//             align-items: center;
//             padding: 0 20px;

//             li {
//                 flex: 0 0 25%;
//                 display: flex;
//                 flex-direction: column;
//                 justify-content: center;
//                 align-items: center;
//                 margin-bottom: 15px;

//                 img {
//                     width: 32px;
//                     height: 32px;
//                     border-radius: 50%;
//                 }

//                 span {
//                     margin-top: 6px;
//                     color: #ABABAB;
//                     font-size: 10px;
//                 }
//             }
//         }
//     }
// 	.texts {
//       width: 100%;
//       height: fit-content;
//       padding: 0 15px 30px 15px;
//       color: #fff;
//       font-size: 13px;
//       line-height: 18px;
// 	  padding-top: 20px;
// 	  position: relative;
// 	  &::before {
//             content: '';
//             display: block;
//             position: absolute;
//             bottom: 0;
//             left: 50%;
// 			transform: translateX(-50%);
//             width: 90%;
//             height: 1px;
//             background: #3f3f3f;
//         }
//     }
// 	.text {
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//       justify-content: center;
//       padding-bottom: 30px;
// 	  padding-top: 20px;
//       p {
//         width: 100%;
//         font-size: 10px;
//         margin: 5px auto;
//         text-align: center;
//         color: #fff;
//       }
//     }
// }
</style>
